import React from 'react'
import { useFormikContext } from 'formik'
import UploadIcon from 'icons/upload'
import CloseIcon from 'icons/close'

// Multi-image uploader bound to a Formik array field. Newly picked files are
// stored as base64 data URLs (the backend uploads them to DO Spaces on save,
// see server/src/utils/restaurant-image.js); existing http URLs are kept as-is.
function GalleryUpload({ name, label }) {
  const formik = useFormikContext()
  const images = formik.values[name] || []

  const readFile = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.readAsDataURL(file)
    })

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []).filter((f) =>
      f.type.startsWith('image/')
    )
    if (!files.length) return
    const encoded = await Promise.all(files.map(readFile))
    formik.setFieldValue(name, [...images, ...encoded])
    e.target.value = '' // allow re-picking the same file
  }

  const removeAt = (index) => {
    formik.setFieldValue(
      name,
      images.filter((_, i) => i !== index)
    )
  }

  return (
    <div className='tw-grow tw-flex tw-flex-col tw-gap-[7px]'>
      {label && (
        <div className='tw-text-[#4A403A] tw-text-[15px] md:tw-text-[13px] tw-font-[500] tw-heading-[20px]'>
          {label}
        </div>
      )}

      <label
        htmlFor={`${name}-input`}
        className='tw-bg-[#F2ECE7] tw-rounded-[5px] tw-min-h-[55px] md:tw-min-h-[40px] tw-px-[11px] tw-flex tw-items-center tw-justify-between tw-cursor-pointer tw-text-inkFaint tw-text-[14px]'
      >
        <span>Add .png or .jpeg images</span>
        <UploadIcon />
      </label>
      <input
        id={`${name}-input`}
        type='file'
        accept='image/png, image/jpeg, image/jpg'
        multiple
        onChange={handleFiles}
        hidden
      />

      {images.length > 0 && (
        <div className='tw-flex tw-flex-wrap tw-gap-2 tw-mt-1'>
          {images.map((src, index) => (
            <div
              key={index}
              className='tw-relative tw-h-20 tw-w-20 tw-overflow-hidden tw-rounded-[6px] tw-border tw-border-[#E7DFD9]'
            >
              <img
                src={src}
                alt=''
                className='tw-h-full tw-w-full tw-object-cover'
              />
              <button
                type='button'
                onClick={() => removeAt(index)}
                className='tw-absolute tw-right-0 tw-top-0 tw-bg-white/80 tw-rounded-bl-[6px] tw-p-[2px]'
              >
                <CloseIcon />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default GalleryUpload
